import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import store from './store';
import 'lib-flexible';
import axios from 'axios';
import vueWechatTitle from "vue-wechat-title";
import './assets/css/vant.css';

Vue.use(vueWechatTitle);
import moment from 'moment';//导入文件
Vue.prototype.$moment = moment;//赋值使用
Vue.config.productionTip = false;

window.bus = new Vue({});
import config from './config';

axios.defaults.timeout = 60000;
let {baseApi} = config;
//配置axios的请求地址
axios.defaults.baseURL = baseApi;
//配置最长响应时间
axios.defaults.timeout = 60000;

//请求拦截器
axios.interceptors.request.use(config => {
  return config;
}, function (error) {
  //请求错误时的回调
  return Promise.reject(error);
});

//相应拦截器
axios.interceptors.response.use(res => {

//请求成功
//     if (res.data.success) {
//         if (res.data.message !== '操作成功') {
//             messageInformation.success({
//                 message: res.data.message
//             });
//         }
//     } else {
//         messageInformation.error({
//             message: res.data.message
//         });
//     }
//   if (res.data.success) {
//     messageInformation.success({
//       message:res.data.message
//     })
//   }else {
//     messageInformation.error({
//       message:res.data.message
//     })
//   }
  
  return res;
}, function (error) {
  //失败的回调
  return Promise.reject(error);
});


window.fetch = function (options) {
  return axios({
    method: options.method || 'GET',
    url: options.url,
    headers: {
      Authorization: sessionStorage.getItem('token')
    },
    data: Object.assign({}, options.data)
  }).catch(
    function (error) {
      console.log(error);
      //捕获后端出错
      // messageInformation.error({
      //   message: '错误码:500,出错了!'
      // });
      
    }
  );
};


Vue.use(Vant);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
